import { Component, OnInit, computed } from '@angular/core';
import { MENU } from '../../core/data/menu.data';
import { Menu } from '../../core/models/menu.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../core/services/notification/notification.service';
import { NeighborhoodService } from '../../core/services/neighborhood/neighborhood.service';
import { StreetBuildingService } from '../../core/services/street-bulding/street-building.service';
import { environment } from '../../../environments/environment';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.scss'
})
export class AppLayoutComponent implements OnInit {

  // Menú filtrado por los módulos habilitados del fraccionamiento (reactivo)
  public menu = computed<Array<Menu>>(() => {
    const neighborhood = this.neighborhoodService.neighborhood();
    return MENU.filter(
      (item) => !item.module || neighborhood?.[item.module] === true
    );
  });

  public title: string = '';

  constructor(
    // public authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private neighborhoodService: NeighborhoodService,
    public notificationService: NotificationService,
    private router: Router,
    public sideMenuServie: SideMenuService,
    private streetBuildingService: StreetBuildingService,
  ) {

    // Escuchar cambios de navegación para capturar parámetros de rutas hijas
    // this.router.events.pipe(
    //   filter(event => event instanceof NavigationEnd),
    //   map(() => this.activatedRoute),
    //   map(route => {
    //     // Navegar hasta la ruta hija más profunda
    //     while (route.firstChild) {
    //       route = route.firstChild;
    //     }
    //     return route;
    //   })
    // ).subscribe(route => {
    //   // Aquí obtienes los parámetros de la ruta activa más profunda
    //   route.params.subscribe(params => {

    //     let companyMenu = COMPANY_MENU.map(
    //       (menuItem) => (
    //         { 
    //           ...menuItem, 
    //           children: menuItem.children 
    //             ? menuItem.children.map(
    //               (child) => (
    //                 { 
    //                   ...child 
    //                 }
    //               )
    //             ) 
    //             : undefined 
    //         }
    //       )
    //     );

    //     console.log('Parámetros de la ruta:', params);
    //     if (params['idEmpresa']) {
    //       // console.log('ID Empresa:', params['idEmpresa']);

    //       const idEmpresa = params['idEmpresa'];

    //       this.title = '';
    //       this.getEmpresa(idEmpresa);

    //       companyMenu.forEach((menuItem) => {

    //         console.log('Menu Item:', menuItem);
            

    //         if(menuItem.route) {
      
    //           menuItem.route = menuItem.route.replace('{idEmpresa}', idEmpresa);
      
    //         } else {
      
    //           menuItem.children?.forEach((submenuItem) => {
      
    //             if(submenuItem.route) {
      
    //               submenuItem.route = submenuItem.route.replace('{idEmpresa}', idEmpresa);
      
    //             }
      
    //           });
      
    //         }
      
    //       });

    //       this.menu = companyMenu;
    //     } else {
    //       this.menu = MENU;
    //       this.title = 'Inicio';
    //     }
    //   });
    // });

  }

  ngOnInit(): void {
    // Cargar notificaciones en background (silencioso, no bloquea el layout)
    this.notificationService.getAll().catch(e => console.log('Error cargando notificaciones:', e));
    // Casas con su chatModule, para saber qué notificaciones de chat son tocables
    this.streetBuildingService.ensureLoaded(environment.neighborhoodId).catch(e => console.log('Error cargando casas:', e));
  }

}
